import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: "user",
    initialState: {
        isLoggedIn: false,
        status: null,
        data: {},
    },
    reducers: {
        setUser: (state, { payload }) => {
            state.isLoggedIn = true
            state.data = { ...state.data, user: payload }
        },
        loggedInUser: (state, { payload }) => {
            state.isLoggedIn = true
            state.data = { ...payload }
        },
        logOutUser: (state, { payload }) => {
            state.isLoggedIn = false
            state.data = {}
            localStorage.removeItem('persist:lasgExamBoard')
            window.location.assign('/')
        },
    },
});

export const { setUser, loggedInUser, logOutUser } = userSlice.actions;

export default userSlice.reducer;